import React from 'react';
import PropTypes from 'prop-types';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';

import { PAYMENT_STATUSES } from '../../../utils/enumHelper';

class BillableStatusSelectComponent extends React.Component {
  render() {
    const {
      onChange,
      value,
      includeAllOption,
      includeExpenseOption,
      ...rest
    } = this.props;
    // Open, Paid, Void,

    return (
      <FormControl fullWidth margin="none" {...rest}>
        <InputLabel id="payment-status-select-label">Status</InputLabel>
        <Select
          labelId="payment-status-select-label"
          id="payment-status-select"
          value={value}
          label="Status"
          onChange={onChange}

        >
          {includeAllOption && <MenuItem value="">All</MenuItem>}
          { PAYMENT_STATUSES.filter((s) => includeExpenseOption || s.enum !== 'Expense').map((nt) => (
            <MenuItem key={`payment-status-menu-item-${nt.enum}`} value={nt.enum}>
              {nt.chip}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }
}

BillableStatusSelectComponent.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
  includeAllOption: PropTypes.bool,
  includeExpenseOption: PropTypes.bool,
};

BillableStatusSelectComponent.defaultProps = {
  onChange: () => {},
  value: null,
  includeAllOption: false,
  includeExpenseOption: true,
};

export default (BillableStatusSelectComponent);
